import State from '../interfaces/State';

export const countriesSelector = (state: State) => state.countries.data;
